// extracted by mini-css-extract-plugin
export default {"energy_value_element":"ingredient-energy-value_energy_value_element__dDKwZ"};